const slugify: Function = (str: string): string => {
    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '')
}

const removeSpecialCharactersExcept = (
    str: string,
    allowedCharacters: string[] = []
): string => {
    const escapedAllowed = allowedCharacters
        .map((char) => char.replace(/[{}()*+?.,\\^$|#\s\-[\]]/g, '\\$&'))
        .join('')
    const pattern = new RegExp(`[^a-zA-Z0-9${escapedAllowed}]`, 'g')

    return str.replace(pattern, '')
}

export { removeSpecialCharactersExcept, slugify }
